import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ParticipantInfo } from 'src/app/generated/participant/participant-info';
import { SaveParticipantInfo } from 'src/app/generated/participant/save-participant-info.command';
import { AppUrls } from 'src/app/shared/app-urls';
import { Observable } from 'rxjs';
import { OfferParticipantInfoDto } from '../../shared/models/offer-participant-info';
import { ConfigurationService } from '../../shared/services/configuration.service';

@Injectable()
export class ParticipantService {
  constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

  /**
   * @deprecated Используйте {@link getParticipantInfo} вместо этого метода.
   */
  public getInfo(): Promise<ParticipantInfo> {
    return this.getParticipantInfo().toPromise();
  }

  public getCountRejection(): Observable<number> {
    const url = `${this.configurationService.configuration.links.tenderPlatformBaseUrl}${AppUrls.rejection.getCount}`;
    return this.http.get<number>(url);
  }

  public getParticipantInfo(): Observable<ParticipantInfo> {
    return this.http.get<ParticipantInfo>(AppUrls.sharedUrls.userInfo);
  }

  public updateInfo(params: SaveParticipantInfo): Promise<any> {
    return this.http.post(AppUrls.participantUrls.info, params).toPromise();
  }

  public getActualInfo(): Observable<OfferParticipantInfoDto> {
    return this.http.get<OfferParticipantInfoDto>(AppUrls.participantUrls.info);
  }
}
